import { BiChevronDown, BiChevronRight, BiPencil, BiPlus } from "react-icons/bi";
import { RowMenu } from "../rowMenu";
import { FiFileText } from "react-icons/fi";
import { BsTrash2 } from "react-icons/bs";
import { SidebarSubcategoryRow } from "./subCategorySidebar";
import { SidebarArticleRow } from "./articleSideBar";
import { ICONS } from "../../../utils/Utils";

export const SidebarCategoryBlock = ({
  category,
  subcategories,
  directArticles,
  selection,
  expandedCategories,
  expandedSubcategories,
  toggleCategory,
  toggleSubcategory,
  onSelectCategory,
  onSelectSubcategory,
  onSelectArticle,
  onEditCategory,
  onDeleteCategory,
  onAddSubcategory,
  onEditSubcategory,
  onDeleteSubcategory,
  onAddArticle,
  onEditArticle,
  onDeleteArticle,
  articlesBySubcategory,
}) => {
  const expanded = expandedCategories.has(category?.id);
  const isSelected = selection.type === "category" && selection.id === category.id;

  return (
    <div className="mb-1">
      <div
        onClick={() => {
          toggleCategory(category.id);
          onSelectCategory();
        }}
        className={`group flex cursor-pointer items-center justify-between gap-2 rounded-lg px-2 py-2 text-sm transition-colors ${isSelected ? "bg-slate-900 text-white" : "text-slate-800 hover:bg-slate-100"
          }`}
      >
        <div className="flex min-w-0 items-center gap-1.5">
          {expanded ? (
            <BiChevronDown
              size={14}
              className={isSelected ? "text-slate-300" : "text-slate-400"}
            />
          ) : (
            <BiChevronRight
              size={14}
              className={isSelected ? "text-slate-300" : "text-slate-400"}
            />
          )}

          <span className="flex h-5 w-5 shrink-0 items-center justify-center text-base leading-none">
            {ICONS[category?.icon]}
          </span>

          <span className="truncate font-medium">
            {category.name}
          </span>
        </div>
        <div className="flex shrink-0 items-center gap-0.5 opacity-0 group-hover:opacity-100">


          <button
            aria-label="Add subcategory"
            title="Add subcategory"
            type="button"
            className={`inline-flex items-center justify-center rounded-md p-1.5 text-slate-500 hover:bg-slate-200/70 hover:text-slate-900 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-600 ${isSelected ? "text-white hover:bg-white/10 hover:text-white" : ""}`}
            onClick={(e) => {
              e.stopPropagation();
              onAddSubcategory();
            }}
          >
            <BiPlus size={14} />
          </button>
          <div className={isSelected ? "text-white" : ""}>
            <RowMenu
              items={[
                { label: "Add article", icon: <FiFileText size={13} />, onClick: onAddArticle },
                { label: "Edit category", icon: <BiPencil size={13} />, onClick: onEditCategory },
                { label: "Delete category", icon: <BsTrash2 size={13} />, onClick: onDeleteCategory, danger: true },
              ]}
            />
          </div>
        </div>
      </div>

      {expanded && (
        <div className="mt-0.5 space-y-0.5 border-l border-slate-200 ml-3 pl-1">
          {subcategories.map((s) => (
            <SidebarSubcategoryRow
              key={s.id}
              subcategory={s}
              articles={articlesBySubcategory(s.id)}
              isSelected={selection.type === "subcategory" && selection.id === s.id}
              selectedArticleId={selection.type === "article" ? selection.id : null}
              expanded={expandedSubcategories.has(s.id)}
              onToggle={() => toggleSubcategory(s.id)}
              onSelect={() => onSelectSubcategory(s)}
              onSelectArticle={onSelectArticle}
              onEdit={() => onEditSubcategory(s)}
              onDelete={() => onDeleteSubcategory(s)}
              onAddArticle={() => onAddArticle(s.id)}
              onEditArticle={onEditArticle}
              onDeleteArticle={onDeleteArticle}
            />
          ))}
          {directArticles.length > 0 && (
            <div className="pt-0.5">
              {directArticles.map((a) => (
                <SidebarArticleRow
                  key={a.id}
                  article={a}
                  isSelected={selection.type === "article" && selection.id === a.id}
                  onSelect={() => onSelectArticle(a)}
                  onEdit={() => onEditArticle(a)}
                  onDelete={() => onDeleteArticle(a)}
                />
              ))}
            </div>
          )}
          {subcategories.length === 0 && directArticles.length === 0 && (
            <p className="pl-9 py-1 text-xs text-slate-400">Empty category</p>
          )}
        </div>
      )}
    </div>
  );
}